<template>
  <div class="console-box">
    <div class="console-container">
      <div class="console-layout">
        <div
          :class="{ 'right-class': $i18n.locale === 'ar' }"
          class="console-title"
        >
          <span>{{ $t("Teller.Console") }}</span>
          <img
            src="../assets/icons/controlls-icon.svg"
            class="controls-button"
          />
        </div>
        <div class="screen-container">
          <div class="console-buttons-container">
            <lbrx-button-icon
              id="callNext"
              v-model="disable"
              icon="next-button-icon"
              @clicked="callNext()"
              :base-button="true"
              :label="$t('Teller.Next')"
              color="#FFFFFF"
              background="#00CC6A"
              height="8.5vmin"
              width="100%"
              font-size="1.3"
            ></lbrx-button-icon>

            <!-- absent btn when no redirect targets -->
             <lbrx-button-icon
              v-if="!hasRedirectionTargets"
              id="callAbsent"
              v-model="waiting_disable"
              icon="delete-button-icon"
              @clicked="callAbsent()"
              :base-button="true"
              :label="$t('Teller.Absent')"
              color="#FFFFFF"
              background="#FF5757"
              height="9vmin"
              width="100%"
              :font-size="hasRedirectionTargets ? 1.9 : 1.3"
              :small="hasRedirectionTargets"
            ></lbrx-button-icon>

            <!--- redirect btns: exactly 2 targets = two buttons side by side with queue titles -->
            <div v-if="hasExactlyTwoRedirectTargets" class="redirect-two-row">
              <lbrx-button-icon
                v-for="(target, idx) in redirectionTargetsList"
                :key="target?.id ?? idx"
                :id="'callRedirect-' + idx"
                v-model="waiting_disable"
                icon="arrow_bear_right"
                @clicked="callRedirect(target)"
                :base-button="true"
                :label="target?.title ?? target?.name ?? $t('Teller.RedirectBTN')"
                color="#FFFFFF"
                background="#008FCA"
                height="8.5vmin"
                width="100%"
                font-size="0.8"
              ></lbrx-button-icon>
            </div>
            <lbrx-button-icon
              v-else-if="hasRedirectionTargets"
              id="callRedirect"
              v-model="waiting_disable"
              icon="arrow_bear_right"
              @clicked="callRedirect()"
              :base-button="true"
              :label="redirectButtonLabel"
              color="#FFFFFF"
              background="#008FCA"
              height="8.5vmin"
              width="100%"
              font-size="0.8"
            ></lbrx-button-icon>
          </div>

          <div class="vert-buttons gap-2">
            <!-- absent btn  when redirect targets next to close -->
            <lbrx-button-icon
              v-if="hasRedirectionTargets"
              id="callAbsent"
              v-model="waiting_disable"
              icon="delete-button-icon"
              @clicked="callAbsent()"
              :base-button="true"
              :label="$t('Teller.Absent')"
              color="#FFFFFF"
              background="#FF5757"
              height="9vmin"
              width="100%"
              :font-size="hasRedirectionTargets ? 1.9 : 1.3"
              :small="hasRedirectionTargets"
            ></lbrx-button-icon>

            <lbrx-button-icon
              v-if="teller_config.business.myLiberrex.queue_on_hold === 1"
              id="callClose"
              v-model="waiting_disable"
              icon="remove-button-icon"
              :small="true"
              @clicked="callClose()"
              :label="$t('Teller.Close')"
              color="#FFFFFF"
              background="#444444"
              height="9vmin"
              width="100%"
              font-size="1.9"
            ></lbrx-button-icon>

            <lbrx-button-icon
              v-if="teller_config.business.myLiberrex.queue_on_hold !== 1"
              id="callClose"
              v-model="waiting_disable"
              icon="stop-icon"
              @clicked="callClose()"
              :label="$t('Teller.Close')"
              :base-button="true"
              color="#FFFFFF"
              background="#444444"
              height="8.5vmin"
              width="100%"
              font-size="1.3"
            ></lbrx-button-icon>

            <lbrx-button-icon
              v-if="teller_config.business.myLiberrex.queue_on_hold === 1"
              id="callWait"
              v-model="waiting_disable"
              icon="hourglass-button-icon"
              :small="true"
              @clicked="callWait()"
              :label="$t('Teller.Waiting')"
              color="#FFFFFF"
              background="#FFCE00"
              height="9vmin"
              width="100%"
              font-size="1.9"
            ></lbrx-button-icon>
          </div>
        </div>
      </div>
      <!-- mobile container -->
      <div class="mobile-container sticky">
        <div class="mobile-container">
          <lbrx-button-icon
            id="callClose"
            v-model="waiting_disable"
            icon="remove-button-icon"
            :small="true"
            @clicked="callClose()"
            color="#FFFFFF"
            background="#444444"
            height="13vmin"
            width="100%"
            font-size="1.9"
          ></lbrx-button-icon>
          <lbrx-button-icon
            v-if="teller_config.business.myLiberrex.queue_on_hold === 1"
            id="callWait"
            v-model="waiting_disable"
            icon="hourglass-button-icon"
            :small="true"
            @clicked="callWait()"
            color="#FFFFFF"
            background="#FFCE00"
            height="13vmin"
            width="100%"
            font-size="1.9"
          ></lbrx-button-icon>
          <lbrx-button-icon
            id="callAbsent"
            v-model="waiting_disable"
            icon="delete-button-icon"
            :small="true"
            @clicked="callAbsent()"
            color="#FFFFFF"
            background="#FF5757"
            height="13vmin"
            width="100%"
            font-size="1.9"
          ></lbrx-button-icon>

          <lbrx-button-icon
            v-if="hasRedirectionTargets"
            id="callRedirect"
            v-model="waiting_disable"
            icon="switch_horizontal"
            :small="true"
            @clicked="callRedirect()"
            color="#FFFFFF"
            background="#008FCA"
            height="13vmin"
            width="100%"
            font-size="1.9"
          ></lbrx-button-icon>

          <lbrx-button-icon
            id="callNext"
            v-model="disable"
            icon="next-button-icon"
            :small="true"
            @clicked="callNext()"
            color="#FFFFFF"
            background="#00CC6A"
            height="13vmin"
            width="100%"
            font-size="1.9"
          ></lbrx-button-icon>
        </div>
      </div>
      <!-- mobile container end -->
    </div>
  </div>
</template>
<script>
import LbrxButtonIcon from "@/components/LbrxButtonIcon.vue";
import { queueService } from "@/_services";

export default {
  name: "LbrxTellerConsole",
  emits: ["sending", "redirect"],
  props: {
    modelValue: Boolean,
    ticket: Object,
    queue: {
      type: Object,
      default: () => ({}),
    },
  },
  components: { LbrxButtonIcon },
  data() {
    return {
      sending: false,
      teller_config: (this.teller_config = JSON.parse(
        localStorage.getItem("user") || "{}",
      )),
      ticketStatus: false,
    };
  },
  watch: {
    ticket: {
      handler: function (newVal) {
        if (newVal !== null) {
          this.ticketStatus = newVal.status !== "inservice";
        }
      },
      deep: true,
    },
  },
  computed: {
    hasRedirectionTargets() {
      const targets = this.queue?.redirection_targets;
      return Array.isArray(targets) && targets.length > 0;
    },
    hasExactlyTwoRedirectTargets() {
      const targets = this.queue?.redirection_targets;
      return Array.isArray(targets) && targets.length === 2;
    },
    redirectionTargetsList() {
      const targets = this.queue?.redirection_targets;
      return Array.isArray(targets) ? targets : [];
    },
    redirectButtonLabel() {
      const targets = this.queue?.redirection_targets;
      if (!Array.isArray(targets) || targets.length === 0)
        return this.$t("Teller.RedirectBTN");
      if (targets.length == 1) {
        const titleTxt = targets[0]?.title ?? "";
        return titleTxt
          ? `${titleTxt}`
          : this.$t("Teller.RedirectBTN");
      }
      return this.$t("Teller.ReditectBTNMultiple");
    },
    disable() {
      return this.modelValue || this.ticket === null;
    },
    waiting_disable() {
      return this.modelValue || this.ticketStatus || this.ticket === null;
    },
  },
  mounted() {
    this.sending = this.modelValue;
  },
  methods: {
    callRedirect(target) {
      if (target != null) {
        this.$emit("redirect", target);
      } else {
        this.$emit("redirect");
      }
    },
    callNext() {
      this.sending = true;
      let counter_config = JSON.parse(localStorage.getItem("counter") || "{}");
      this.$emit("resetstat");
      this.$emit("sending");
      queueService
        .callNext(counter_config.queue_id)
        .then((res) => {
          localStorage.setItem(
            "public_identifier",
            JSON.stringify(res.customer.public_identifier),
          );
          const st = res.customer.status || "inservice";
          localStorage.setItem("public_ticket_status", String(st));
          this.$emit("callNext", res);
          // Notify any listeners in the same window immediately
          window.dispatchEvent(
            new CustomEvent("public-identifier-updated", {
              detail: { value: res.customer.public_identifier },
            }),
          );
        })
        .catch((err) => {
          console.log(err);
          this.$emit("callNext", null);
          localStorage.setItem("public_identifier", "-");
          localStorage.removeItem("public_ticket_status");
          window.dispatchEvent(new CustomEvent("public-identifier-updated"));
        });

      setTimeout(() => {
        this.sending = false;
      }, 1000);
    },
    callAbsent() {
      this.sending = true;
      this.$emit("sending");
      this.$emit("ticketAbsent");
      setTimeout(() => {
        this.sending = false;
      }, 1000);
    },
    callClose() {
      this.sending = true;
      this.$emit("endTicket");
      setTimeout(() => {
        this.sending = false;
      }, 1000);
    },
    callWait() {
      this.sending = true;
      this.$emit("sending");
      this.$emit("holdTicket");
      setTimeout(() => {
        this.sending = false;
      }, 1000);
    },
  },
};
</script>
<style scoped>
@media (max-width: 680px) {
  @media (max-width: 767px) {
    .sticky {
      z-index: 1;
      position: fixed !important;
      bottom: 7vh !important;
      left: 0 !important;
      right: 0 !important;
      font-size: 20px !important;
    }
  }
  .console-box {
    padding: 0 !important;
    margin: 0 !important;
    width: 100% !important;
  }

  .screen-container {
    display: none !important;
  }

  .mobile-container {
    display: flex !important;
    width: 100% !important;
    padding: 0 !important;
  }

  .console-title {
    display: none !important;
  }
}

.controls-button {
  height: 3.5vmin;

}

.mobile-container {
  display: none;
}

.vert-buttons {
  display: flex;
}

.redirect-two-row {
  display: flex;
  width: 100%;
  gap: 1.5vmin;
}

.console-buttons-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 1.5vmin;
}

.console-layout {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: flex-start;
}

.console-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  font-family: "Exo 2", serif;
  font-style: normal;
  font-weight: 400 !important;
  font-size: 2.4vmin;
  line-height: 2vmin;
  color: #8a8a8a;
}

.screen-container {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  gap: 1.5vmin;
}

.console-container {
  margin: auto;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.console-box {
  padding: 20px;
  width: 100% !important;
  height: 100% !important;
  background: white;
}
</style>
